import { Component, OnInit, Input } from '@angular/core';
import { ChooseServiceComponent } from '../diary/choose-service/choose-service.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-my-reservation',
    templateUrl: './my-reservation.component.html',
    styleUrls: ['./my-reservation.component.sass'],
    standalone: false
})

export class MyReservationComponent implements OnInit {
  @Input() tip_service : any = {}
  @Input() kilometraje : any = {}
  @Input() taller : any = {}
@Input ()cityName : any = {}
  @Input() asesor : any = {}

  @Input() date: any = {}
  @Input() time:any ={}
  @Input() LanguageForCountry:any ={}
  
  constructor(private translate: TranslateService) { 

  }
  // datoresv = ChooseServiceComponent.dato

  ngOnInit(): void {
    

  }

}
